/**
 * Görseli cihaza indirir.
 *
 * Mobil tarayıcı/webview'de doğrudan indirme çoğu zaman engellendiği için önce
 * paylaşım sayfası (Fotoğraflar / Dosyalar'a kaydet) denenir, olmazsa klasik
 * indirme bağlantısına düşülür.
 */
const baglantiyiTetikle = (url, dosyaAdi) => {
  const baglanti = document.createElement('a');
  baglanti.href = url;
  baglanti.download = dosyaAdi;
  baglanti.rel = 'noopener';
  document.body.appendChild(baglanti);
  baglanti.click();
  document.body.removeChild(baglanti);
};

export const gorseliIndir = async (src, dosyaAdi, baslik) => {
  try {
    const yanit = await fetch(src);
    const blob = await yanit.blob();
    const dosya = new File([blob], dosyaAdi, { type: blob.type || 'image/jpeg' });

    if (navigator.canShare?.({ files: [dosya] })) {
      try {
        await navigator.share({ files: [dosya], title: baslik || dosyaAdi });
        return;
      } catch (hata) {
        // Kullanıcı paylaşımdan vazgeçtiyse indirmeye düşme
        if (hata?.name === 'AbortError') return;
      }
    }

    const blobUrl = URL.createObjectURL(blob);
    baglantiyiTetikle(blobUrl, dosyaAdi);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
  } catch {
    // fetch engellenirse görselin kendi adresiyle dene
    baglantiyiTetikle(src, dosyaAdi);
  }
};

/** "Tip 1 · 3+1 · 136 m²" → "Tip-1-3+1-136-m2" */
export const dosyaAdiUret = (metin) => metin
  .replace(/m²/g, 'm2')
  .replace(/[ı]/g, 'i').replace(/[İ]/g, 'I')
  .replace(/[ğ]/g, 'g').replace(/[Ğ]/g, 'G')
  .replace(/[ü]/g, 'u').replace(/[Ü]/g, 'U')
  .replace(/[ş]/g, 's').replace(/[Ş]/g, 'S')
  .replace(/[ö]/g, 'o').replace(/[Ö]/g, 'O')
  .replace(/[ç]/g, 'c').replace(/[Ç]/g, 'C')
  .replace(/[^a-zA-Z0-9+]+/g, '-')
  .replace(/^-+|-+$/g, '');
